import React, {Component} from 'react';
import {
    Button,
    Table,
    Header
} from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import {FormattedNumber, FormattedDate, FormattedTime} from 'react-intl';
import update from 'react-addons-update';

import DeliveryState from '../../components/sale/DeliveryState';
import SaleData from "../../data/SaleData";
import NoData from "../../components/extras/NoData";
import MainToolbar from "../../components/extras/MainToolbar";
import LoadingRow from "../../components/extras/LoadingRow";
import localDB from "../../data/localDB";
import {showFindClientModal} from "../../actions/FindClientAction";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";

class Orders extends Component {

    constructor() {
        super();
        this.state = {
            data: {
                count: 0,
                next: "",
                previous: "",
                results: []
            },
            loading: true,
            page: 1,
            search: "",
            header: ['Nº', 'Fecha de Solicitud', 'Fecha de Entrega', 'Cliente', 'Notas', 'Estado', 'Total', 'Acciones']
        };

        this.initialFetch = this.initialFetch.bind(this);
        this.updateClientData = this.updateClientData.bind(this);
        this.goSale = this.goSale.bind(this);
    }

    componentDidMount() {
        this.initialFetch("", 1);
    };

    componentWillReceiveProps(nextProps){
        if(nextProps.select_client){
            this.selectClient(nextProps.select_client);
        }
    }

    goSale = (sale) => {
        localDB.saveSaleStorage(sale, 'sale');
        this.props.history.push(`/sale/view/${sale.billing_number}`);
    };

    updateClientData = (res, index) => {
        let oldData = this.state.data.results.slice();
        oldData[index].client = res;
        let data = update(this.state, {
            data: {
                results: {
                    $set: oldData
                }
            }
        });
        this.setState(data);
    };

    selectClient = (client) => {
        let data = {
            order: {
                quantity: 0,
                waiter: null,
                type: 3,
                delivery_state: 1,
                client: client.id
            },
        };
        SaleData.open(data, (res) => {
            this.refs.toolbar.sending();
            if (res.hasOwnProperty('id')) {
                SaleData.get(res.id, (sale) => {
                    if (sale.hasOwnProperty('id')) {
                        let oldData = this.state.data.results.slice();
                        oldData.unshift(sale);

                        let orders = update(this.state, {
                            data: {
                                results: {
                                    $set: oldData
                                }
                            }
                        });
                        this.setState(orders);
                        this.goSale(sale);
                    }
                    else {
                        this.setState({sending: false});
                        this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                    }
                });
            } else {
                this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
            }
        });
    };

    async initialFetch(search, page) {
        let data = await SaleData.ordersList(search, page);
        if (this.state.page === 1) {
            this.setState({data, loading: false});
        } else {
            let oldData = this.state.data.results.slice();
            let newData = update(this.state, {
                data: {
                    results: {
                        $set: oldData.concat(data.results)
                    },
                    next: {
                        $set: data.next
                    }
                }
            });
            this.setState(newData);
        }
    };

    handleSearch = (search) => {
        this.initialFetch(search, 1)
    };

    loadMore = () => {
        let page = this.state.page + 1;
        let search = this.state.search;
        this.setState({page: page, search: search});
        this.initialFetch(search, page);
    };

    render() {
        let rows = this.state.data.results.length > 0 ? this.state.data.results.map(function (order, index) {
            return (
                <Table.Row key={order.id}>
                    <Table.Cell>
                        {("0000000" + order.billing_number).slice(-4)}
                    </Table.Cell>
                    <Table.Cell>
                        <FormattedDate value={order.date}/> - <FormattedTime value={order.date}/>
                    </Table.Cell>
                    <Table.Cell>
                        <FormattedDate value={order.date_out}/> - <FormattedTime value={order.date_out}/>
                    </Table.Cell>
                    <Table.Cell>
                        {order.client ? order.client.full_name:null}
                    </Table.Cell>
                    <Table.Cell>
                        {order.notes}
                    </Table.Cell>
                    <Table.Cell>
                        <DeliveryState state={order.delivery_state} id={order.id} all_options={true}/>
                    </Table.Cell>
                    <Table.Cell>
                        <Header as='h3' textAlign='center' style={{margin:'0px'}}>
                            Total Venta: $<FormattedNumber
                            value={order.total.total_sale}
                            currency="USD"
                            maximumFractionDigits={0}
                            minimumFractionDigits={0}
                        />
                        </Header>
                        {
                            order.total.balance !== 0 ? <Header as='h3' textAlign='center' style={{margin:'0px'}} color='orange'>
                                Saldo: $<FormattedNumber
                                value={order.total.balance}
                                currency="USD"
                                maximumFractionDigits={0}
                                minimumFractionDigits={0}
                            />
                            </Header>:null
                        }
                    </Table.Cell>
                    <Table.Cell>
                        <Button content='Ver Venta' fluid primary
                                onClick={() => this.goSale(order, index)}/>
                    </Table.Cell>
                </Table.Row>
            )
        }, this) : <NoData colSpan={8}/>;

        let loadMore = <Table.Row>
            <Table.Cell colSpan={8}>
                <Button fluid onClick={() => this.loadMore()}>Cargar Más</Button>
            </Table.Cell>
        </Table.Row>;

        let header = this.state.header.map(function (header, i) {
            return (
                <Table.HeaderCell key={i}>
                    {header}
                </Table.HeaderCell>
            )
        }, this);

        let table = <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan='8'>
                        <MainToolbar
                            title="Pedidos"
                            name="Pedido"
                            ref="toolbar"
                            icon="food"
                            btnAdd={true}
                            callbackAdd={() => this.props.showFindClientModal({open:true, client:{id:null}})}
                            callbackSearch={this.handleSearch}
                        />
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Header>
                <Table.Row>
                    {header}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {this.state.loading ? <LoadingRow colSpan={5}/> : rows}
                {this.state.data.next ? loadMore : null}
            </Table.Body>
        </Table>;

        return (
            <div>
                {table}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        select_client: state.get('select_client'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showFindClientModal(data){
            dispatch(showFindClientModal(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Orders));


// WEBPACK FOOTER //
// ./src/containers/sale/Orders.js